import { render, staticRenderFns } from "./addQuestionDialog.vue?vue&type=template&id=4d2bb5fa&scoped=true&"
import script from "./addQuestionDialog.vue?vue&type=script&lang=js&"
export * from "./addQuestionDialog.vue?vue&type=script&lang=js&"
import style0 from "./addQuestionDialog.vue?vue&type=style&index=0&id=4d2bb5fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2bb5fa",
  null
  
)

export default component.exports